import axios from 'axios'

console.log('process.env.VUE_APP_BASE_API', process.env.VUE_APP_BASE_API)
// 创建axios实例

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 15000 // 请求超时的时间
})

// axios 请求拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  return config
}, error => {
  Promise.reject(error)
})

// axios 响应拦截器
service.interceptors.response.use(response => {
  const res = response.data
  if (res.errorCode !== 200) {
    return response.data
  } else {
    return response.data
  }
}, error => {
  console.log('err' + error) // fordebug
  return Promise.reject(error)
})

export default service
